const base =
    "inline-flex items-center justify-center gap-3 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 select-none active:scale-[0.98]";

export function ButtonGold({ children, onClick, href, tid, className = "", type = "button" }) {
    const cls = `${base} border border-gold bg-gold text-[#0a0a0a] hover:bg-gold-bright hover:border-gold-bright hover:shadow-[0_0_44px_rgba(201,162,39,0.28)] ${className}`;
    if (href) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={tid} onClick={onClick}>
                {children}
            </a>
        );
    }
    return (
        <button type={type} onClick={onClick} className={cls} data-testid={tid}>
            {children}
        </button>
    );
}

export function ButtonGhost({ children, onClick, href, tid, className = "", type = "button" }) {
    const cls = `${base} border border-white/15 bg-transparent text-white hover:border-gold-line hover:text-gold ${className}`;
    if (href) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={tid} onClick={onClick}>
                {children}
            </a>
        );
    }
    return (
        <button type={type} onClick={onClick} className={cls} data-testid={tid}>
            {children}
        </button>
    );
}
